// Pretvara izabranu sliku u manji logo (data URL) za čuvanje uz podatke agencije.
// Smanjuje na najviše 600×240 px, da faktura i baza ostanu lagane.
export function fileToLogoDataUrl(file) {
  return new Promise((resolve, reject) => {
    if (!file || !/^image\/(png|jpe?g|webp|svg\+xml|gif)$/.test(file.type)) {
      reject(new Error('Izaberite sliku (PNG, JPG, WEBP ili SVG).'));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Slika nije mogla da se učita.'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Slika nije mogla da se učita.'));
      img.onload = () => {
        const maxW = 600;
        const maxH = 240;
        const w0 = img.naturalWidth || img.width || maxW;
        const h0 = img.naturalHeight || img.height || maxH;
        const scale = Math.min(1, maxW / w0, maxH / h0);
        const w = Math.max(1, Math.round(w0 * scale));
        const h = Math.max(1, Math.round(h0 * scale));
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        const keepAlpha = file.type !== 'image/jpeg';
        if (!keepAlpha) { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); }
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL(keepAlpha ? 'image/png' : 'image/jpeg', 0.9));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
